import React from 'react';

export const TokenContext = React.createContext();

export const UserContext = React.createContext();

export const NotificationContext = React.createContext();

export const LocationContext = React.createContext();

export const ThemesContext = React.createContext();